import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => { const c = useContext(AuthContext); if (!c) throw new Error('useAuth must be used within AuthProvider'); return c; };

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => { checkAuth(); }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    try { const res = await api.get('/auth/me'); setUser(res.data.data.user); setIsAuthenticated(true); }
    catch { localStorage.removeItem('token'); setUser(null); setIsAuthenticated(false); }
    finally { setLoading(false); }
  };

  const login = async (email, password) => {
    const res = await authAPI.login(email, password);
    const { token, user: userData } = res.data.data;
    localStorage.setItem('token', token);
    setUser(userData); setIsAuthenticated(true);
    return res.data;
  };

  const register = async (userData) => {
    const res = await authAPI.register(userData);
    const { token, user: newUser } = res.data.data;
    localStorage.setItem('token', token);
    setUser(newUser); setIsAuthenticated(true);
    return res.data;
  };

  const logout = () => { localStorage.removeItem('token'); setUser(null); setIsAuthenticated(false); };
  const updateUser = (u) => setUser({ ...user, ...u });

  return <AuthContext.Provider value={{ user, loading, isAuthenticated, login, register, logout, updateUser }}>{children}</AuthContext.Provider>;
};

const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (data) => api.post('/auth/register', data)
};
